import { render } from "./BlogSection.vue?vue&type=template&id=0f98ef48&scoped=true&ts=true"
import script from "./BlogSection.vue?vue&type=script&lang=ts"
export * from "./BlogSection.vue?vue&type=script&lang=ts"

import "./BlogSection.vue?vue&type=style&index=0&id=0f98ef48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f98ef48"]])

export default __exports__